import { Archive } from "src/app/modules/bootstrap/rocket-ui/backend/models/archive";
import { Backup } from "src/app/modules/bootstrap/rocket-ui/backend/models/backup";

export enum AlarmEventLevel {
  LOW = "low",
  MEDIUM = "medium",
  HIGH = "high",
  URGENT = "urgent",
  CRITICAL = "critical",
  NONE = "none"
}

export type AlarmEvent = {
  level: AlarmEventLevel;
  message: {
    key: string;
    params?: Record<string, any>;
    label: string;
  };
  createdAt: string;
};

export interface Alarm {
  id: string;
  version: number;
  account: string;
  tenant: string;
  createdAt: string;
  createdBy?: {
    id: string;
    name: string;
  };
  updatedAt?: string;
  deletedAt?: string;
  correlationId: string;
  resource: {
    id: string;
    type: string;

    backup?: Backup;
    archive?: Archive;
  };
  events: AlarmEvent[];

  closed: boolean;
  closedAt?: string;
  closedBy?: {
    id: string;
    name: string;
  };

  level: AlarmEventLevel;
  mostRecentEvent?: AlarmEvent;
}
